import Padding from '@/components/padding/Padding';
import heroImage from '@/images/heroimage.png';
import { Box, Heading, HStack, Icon, Image, List, Text } from '@chakra-ui/react';
import React from 'react';
import { FaCheckSquare } from 'react-icons/fa';

const Hero = (): React.JSX.Element => {
  return (
    <div className="hero-mesh" style={{ backgroundColor: '#16161f' }}>
      <Padding verticalPadding={20}>
        <Box className="flex flex-col md:flex-row items-center" gap={8}>
          <Box flex="1" display="flex" flexDirection="column" justifyContent="center">
            <Text
              as="p"
              color="white"
              style={{
                fontWeight: 'bold',
                fontFamily: 'Bebas Neue',
                fontSize: '4rem',
                lineHeight: '1.0',
              }}
            >
              <>
                <Text as="span" display="block">
                  Run your club
                </Text>
                <Text as="span" display="block">
                  Not the admin
                </Text>
              </>
            </Text>
            <Heading
              as="h1"
              color="white"
              fontWeight="normal"
              mb={0}
              size="md"
              style={{ fontFamily: 'Lato' }}
            >
              <Text fontSize="md" color="inherit">
                Olympiq is a free all-in-one sports club management solution. Custom club website,
                membership management system, and session booking app.
              </Text>
            </Heading>
            <Box mt={4} fontSize="lg" color="white">
              <List.Root
                listStyleType="none"
                pl={0}
                style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}
              >
                <List.Item className="bg-[#FFFFFF10] p-3 rounded-md">
                  <HStack align="start" gap={3}>
                    <Icon as={FaCheckSquare} color="green.400" boxSize={5} />
                    <Text fontSize="md">
                      <Text as="span" display="block" fontWeight="semibold">
                        Custom Club Website
                      </Text>
                      <Text as="span" display="block">
                        A professional club website on your own domain, which handles signup and
                        renewals for you!
                      </Text>
                    </Text>
                  </HStack>
                </List.Item>
                <List.Item className="bg-[#FFFFFF10] p-3 rounded-md">
                  <HStack align="start" gap={3}>
                    <Icon as={FaCheckSquare} color="green.400" boxSize={5} />
                    <Text fontSize="md">
                      <Text as="span" display="block" fontWeight="semibold">
                        Membership Management
                      </Text>
                      <Text as="span" display="block">
                        Manage members all within your own club website. No external systems or
                        third-party logins required.
                      </Text>
                    </Text>
                  </HStack>
                </List.Item>
                <List.Item className="bg-[#FFFFFF10] p-3 rounded-md">
                  <HStack align="start" gap={3}>
                    <Icon as={FaCheckSquare} color="green.400" boxSize={5} />
                    <Text fontSize="md">
                      <Text as="span" display="block" fontWeight="semibold">
                        Session Booking App
                      </Text>
                      <Text as="span" display="block">
                        Members book sessions directly in the club mobile app. Fully integrated with
                        your membership database. Let it even faciliate trial sessions for
                        prospective members for you!
                      </Text>
                    </Text>
                  </HStack>
                </List.Item>
              </List.Root>
            </Box>
          </Box>
          <Box flex="1">
            <Image src={heroImage} alt="Olympiq sports club management dashboard illustration" />
          </Box>
        </Box>
      </Padding>
    </div>
  );
};

export default Hero;
